import { useMemo, useState } from 'react';
import { LangType, validateLang } from '../../../../../../../../helpers/lang';
import { validate } from '../../../../../../../../helpers/validate';
import { useLang } from '../../../../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../../../../hooks/use-query-params';
import { useDishCategoryStore } from '../../../../../../../../store/use-dish-category-store';
import { useDishStore } from '../../../../../../../../store/use-dish-store';
import { IdValue } from '../../../../../../../../types/props';
import { getCurrentMenu } from '../../../menu-informer-helpers';
import { useInputLangStore } from '../../../../../../../../store/use-input-lang-store';
import { DishCategoryType } from '../../../../../../../../store/api/dish-category-api';

export const useMenuInformerCreateCategoryModal = () => {
  const { t, getLocale } = useLang();

  const { setDishListOrder } = useDishStore();
  const { postCategory, isLoading, putCategory, deleteCategory, setCategoryListOrder } =
    useDishCategoryStore();
  const { language } = useInputLangStore();

  const menu = getCurrentMenu();

  const [section, setSection] = useState<IdValue>();

  const { sections, categories } = useMemo(() => {
    const sections: IdValue[] =
      menu?.sections?.map((item) => ({ id: String(item.id), value: getLocale(item.name) })) || [];

    const categories =
      menu?.sections?.find((item) => String(item.id) === section?.id)?.categories || [];

    return { sections, categories };
  }, [menu, section]);

  const handleUpdate = async (item: DishCategoryType) => {
    const isValid = validate({ editCategoryName: { rule: () => validateLang(item.name) } });
    if (!isValid) return;
    await putCategory(item);
  };

  const handleCreate = async (data: LangType = {}) => {
    const isValid = validate({ createCategoryName: { rule: () => validateLang(data) } });
    if (!section || !isValid) return;
    await postCategory({ name: data, section_id: Number(section.id) });
  };

  const { addQueryParams } = useQueryParams();

  return {
    t,
    handleUpdate,
    section,
    getLocale,
    sections,
    setSection,
    categories,
    handleCreate,
    isLoading,
    setDishListOrder,
    deleteCategory,
    addQueryParams,
    setCategoryListOrder,

    language,
  };
};
